import axios from "axios";
import qs from "qs";
import moment from "moment";

const state = {
  orderReports: [],
  venueReports: [],
  venueNameList: [],
  graphicReports: {},
  loading: false,
  storeAccountingList: [],
  storeMonthlyInvoiceDetail: [],
  storeMonthlyInvoiceDetailTotalAmount: 0,
  invoicePeriods: [],
  storeMonthlyInvoiceSummary: [],
};

const getters = {
  allOrderReports: (state) => state.orderReports,
  allVenueReports: (state) => state.venueReports,
  allVenueNameList: (state) => state.venueNameList,
  allGraphicReports: (state) => state.graphicReports,
  loading: (state) => state.loading,
  allStoreAccountingList: (state) => state.storeAccountingList,
  allStoreMonthlyInvoiceDetail: (state) => state.storeMonthlyInvoiceDetail,
  allStoreMonthlyInvoiceDetailTotalAmount: (state) =>
    state.storeMonthlyInvoiceDetailTotalAmount,
  allInvoicePeriods: (state) => state.invoicePeriods,
  allStoreMonthlyInvoiceSummary: (state) => state.storeMonthlyInvoiceSummary,
};

const actions = {
  getOrderReports({ commit }, filters) {
    commit("setLoading", true);
    const queryString = qs.stringify(
      {
        page: filters.pageNumber,
        size: filters.pageSize,
        search: filters.search,
        startDate: filters.startDate
          ? moment(filters.startDate, "DD/MM/YYYY").format(
              "YYYY-MM-DDTHH:mm:ss",
            )
          : filters.startDate,
        endDate: filters.endDate
          ? moment(filters.endDate, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss")
          : filters.endDate,
        orderBy: filters.orderBy,
      },
      {
        skipNulls: true,
        filter: (prefix, value) => (value !== "" ? value : undefined),
      },
    );
    return axios
      .get(`/api/panel/report/orders?${queryString}`, { timeout: 100000 })
      .then((response) => {
        response.data.payload.items = response.data.payload.items.map((x) => {
          x.orderDate = moment(x.orderDate, "YYYY-MM-DDTHH:mm:ss").format(
            "DD.MM.YYYY hh:mm",
          );
          x.deliveredDate = moment(
            x.deliveredDate,
            "YYYY-MM-DDTHH:mm:ss",
          ).format("DD.MM.YYYY hh:mm");
          x.deliveredAccessDate = x.deliveredAccessDate
            ? moment(x.deliveredAccessDate, "YYYY-MM-DDTHH:mm:ss").format(
                "DD.MM.YYYY hh:mm",
              )
            : "-";
          return x;
        });
        commit("setOrderReports", response.data.payload.items);
        commit("setLoading", false);
        return response.data.payload;
      });
  },
  getVenueReports({ commit }, filters) {
    commit("setLoading", true);
    const queryString = qs.stringify(
      {
        page: filters.pageNumber,
        size: filters.pageSize,
        search: filters.search,
        startDate: filters.startDate
          ? moment(filters.startDate, "DD/MM/YYYY").format(
              "YYYY-MM-DDTHH:mm:ss",
            )
          : filters.startDate,
        endDate: filters.endDate
          ? moment(filters.endDate, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss")
          : filters.endDate,
        orderBy: filters.orderBy,
      },
      {
        skipNulls: true,
        filter: (prefix, value) => (value !== "" ? value : undefined),
      },
    );
    return axios
      .get(`/api/panel/report/venues?${queryString}`, { timeout: 100000 })
      .then((response) => {
        response.data.payload.items = response.data.payload.items.map((x) => {
          x.createDate = moment(x.createDate, "YYYY-MM-DDTHH:mm:ss").format(
            "DD.MM.YYYY",
          );
          return x;
        });
        commit("setVenueReports", response.data.payload.items);
        commit("setLoading", false);
        return response.data.payload;
      });
  },
  getGraphicReports({ commit }, filters) {
    const queryString = qs.stringify(
      {
        startDate: filters.startDate
          ? moment(filters.startDate, "YYYY-MM-DD").format(
              "YYYY-MM-DDTHH:mm:ss",
            )
          : filters.startDate,
        endDate: filters.endDate
          ? moment(filters.endDate, "YYYY-MM-DD").format("YYYY-MM-DDTHH:mm:ss")
          : filters.endDate,
      },
      {
        skipNulls: true,
        filter: (prefix, value) => (value !== "" ? value : undefined),
      },
    );
    return axios
      .get(`/api/panel/report/graphics?${queryString}`, { timeout: 100000 })
      .then((response) => {
        commit("setGraphicReports", response.data.payload);
        return response.data.payload;
      });
  },
  getVenueNameList({ commit }) {
    return axios
      .get(`/api/panel/venue/venue-name-list`, { timeout: 100000 })
      .then((response) => {
        commit("setVenueNameList", response.data.payload);
        return response.data.payload;
      });
  },
  getVenueExportReports({ commit }, filters) {
    const queryString = qs.stringify(
      {
        search: filters.search,
        startDate: filters.startDate
          ? moment(filters.startDate, "DD/MM/YYYY").format(
              "YYYY-MM-DDTHH:mm:ss",
            )
          : filters.startDate,
        endDate: filters.endDate
          ? moment(filters.endDate, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss")
          : filters.endDate,
        venueId: filters.venueId,
      },
      {
        skipNulls: true,
        filter: (prefix, value) => (value !== "" ? value : undefined),
      },
    );

    axios({
      url: `/api/panel/report/venues/export?${queryString}`,
      method: "GET",
      responseType: "blob", // important
      timeout: 100000,
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `rapor${new Date().toISOString().substr(0, 10)}.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
    });
  },
  getOrderExportReports({ commit }, filters) {
    const queryString = qs.stringify(
      {
        page: filters.pageNumber,
        size: filters.pageSize,
        search: filters.search,
        startDate: filters.startDate
          ? moment(filters.startDate, "DD/MM/YYYY").format(
              "YYYY-MM-DDTHH:mm:ss",
            )
          : filters.startDate,
        endDate: filters.endDate
          ? moment(filters.endDate, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss")
          : filters.endDate,
        orderBy: filters.orderBy,
      },
      {
        skipNulls: true,
        filter: (prefix, value) => (value !== "" ? value : undefined),
      },
    );

    console.log("queryString", queryString);
    axios({
      url: `/api/panel/report/orders/export?${queryString}`,
      method: "GET",
      responseType: "blob", // important
      timeout: 100000,
    }).then((response) => {
      console.log(response);
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `rapor${new Date().toISOString().substr(0, 10)}.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
    });
  },
  getStoreAccountingList({ commit }, filters) {
    commit("setLoading", true);
    const queryString = qs.stringify(
      {
        page: filters.pageNumber,
        size: filters.pageSize,
        CompanyName: filters.CompanyName,
        BranchName: filters.BranchName,
        TaxIdentityNumber: filters.TaxIdentityNumber,
        StartDate: filters.StartDate,
        EndDate: filters.EndDate,
      },
      {
        skipNulls: true,
        filter: (prefix, value) => (value !== "" ? value : undefined),
      },
    );
    return axios
      .get(`/api/panel/report/store-accounting?${queryString}`, {
        timeout: 100000,
      })
      .then((response) => {
        commit("setStoreAccountingList", response.data.payload.items);
        commit("setLoading", false);
        return response.data.payload;
      });
  },
  async getStoreAccountingReports({ commit }, filters) {
    commit("setLoading", true);
    const queryString = qs.stringify(
      {
        CompanyName: filters.CompanyName,
        BranchName: filters.BranchName,
        TaxIdentityNumber: filters.TaxIdentityNumber,
        StartDate: filters.StartDate,
        EndDate: filters.EndDate,
      },
      {
        skipNulls: true,
        filter: (prefix, value) => (value !== "" ? value : undefined),
      },
    );

    return await axios({
      url: `/api/panel/report/store-accounting/${
        filters.type === "csv" ? "export-csv" : "export"
      }?${queryString}`,
      method: "GET",
      responseType: "blob",
      timeout: 100000,
    })
      .then((response) => {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `magaza_muhasebe_rapor_${new Date().toISOString().substr(0, 10)}.${
            filters.type === "csv" ? "csv" : "xlsx"
          }`,
        );
        document.body.appendChild(link);
        link.click();
        return response;
      })
      .catch(async (err) => {
        const data = JSON.parse(await err.response.data.text());
        err.response.data = data;
        const res = err.response;
        return res;
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },
  getStoreMonthlyInvoiceDetail({ commit }, filters) {
    commit("setLoading", true);
    const queryString = qs.stringify(
      {
        Page: filters.pageNumber,
        size: filters.pageSize,
        VenueIds: filters.venueIds,
        Periods: filters.invoicePeriods,
      },

      {
        skipNulls: true,
        filter: (prefix, value) => (value !== "" ? value : undefined),
        arrayFormat: "repeat",
      },
    );
    return axios
      .get(`/api/panel/report/monthly-invoice-detail?${queryString}`, {
        timeout: 100000,
      })
      .then((response) => {
        commit("setStoreMonthlyInvoiceDetail", response.data.payload.items);
        commit(
          "setStoreMonthlyInvoiceDetailTotalAmount",
          response.data.payload.totalAmount,
        );

        commit("setLoading", false);
        return response.data.payload;
      });
  },
  async getStoreMonthlyInvoiceDetailReports({ commit }, filters) {
    commit("setLoading", true);
    const queryString = qs.stringify(
      {
        VenueIds: filters.venueIds,
        Periods: filters.invoicePeriods,
      },
      {
        skipNulls: true,
        filter: (prefix, value) => (value !== "" ? value : undefined),
        arrayFormat: "repeat",
      },
    );

    return await axios({
      url: `/api/panel/report/monthly-invoice-detail/${
        filters.type === "csv" ? "export-csv" : "export"
      }?${queryString}`,
      method: "GET",
      responseType: "blob",
      timeout: 100000,
    })
      .then((response) => {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Detay_Rapor_${new Date().toISOString().substr(0, 10)}.${
            filters.type === "csv" ? "csv" : "xlsx"
          }`,
        );
        document.body.appendChild(link);
        link.click();
        return response;
      })
      .catch(async (err) => {
        const data = JSON.parse(await err.response.data.text());
        err.response.data = data;
        const res = err.response;
        return res;
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },
  getInvoicePeriods({ commit }, filters) {
    function generateYearMonthItems(yearCount) {
      const items = [];
      const now = new Date();

      for (let i = 0; i < yearCount * 12; i++) {
        const d = new Date(now);
        d.setMonth(now.getMonth() - i);

        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");

        items.push({
          text: `${year}-${month}`,
          value: `${year}-${month}`,
        });
      }

      commit("setInvoicePeriods", items);

      return items;
    }

    const months = generateYearMonthItems(5);

    return months;
  },
  getStoreMonthlyInvoiceSummary({ commit }, filters) {
    commit("setLoading", true);
    const queryString = qs.stringify(
      {
        Page: filters.pageNumber,
        size: filters.pageSize,
        CompanyName: filters.CompanyName,
        Periods: filters.invoicePeriods,
      },

      {
        skipNulls: true,
        filter: (prefix, value) => (value !== "" ? value : undefined),
        arrayFormat: "repeat",
      },
    );
    return axios
      .get(`/api/panel/report/monthly-invoice-summary?${queryString}`, {
        timeout: 100000,
      })
      .then((response) => {
        commit("setStoreMonthlyInvoiceSummary", response.data.payload.items);
        commit("setLoading", false);
        return response.data.payload;
      });
  },
  async getStoreMonthlyInvoiceSummaryReports({ commit }, filters) {
    commit("setLoading", true);
    const queryString = qs.stringify(
      {
        CompanyName: filters.CompanyName,
        Periods: filters.invoicePeriods,
      },
      {
        skipNulls: true,
        filter: (prefix, value) => (value !== "" ? value : undefined),
        arrayFormat: "repeat",
      },
    );
    return await axios({
      url: `/api/panel/report/monthly-invoice-summary/${
        filters.type === "csv" ? "export-csv" : "export"
      }?${queryString}`,
      method: "GET",
      responseType: "blob",
      timeout: 100000,
    })
      .then((response) => {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Ozet_Rapor_${new Date().toISOString().substr(0, 10)}.${
            filters.type === "csv" ? "csv" : "xlsx"
          }`,
        );
        document.body.appendChild(link);
        link.click();
        return response;
      })
      .catch(async (err) => {
        const data = JSON.parse(await err.response.data.text());
        err.response.data = data;
        const res = err.response;
        return res;
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },
  async deleteStoreInvoice({ commit }, postData) {
    commit("setLoading", true);
    return axios
      .post(`/api/panel/report/venue-invoice/delete`, postData, {
        timeout: 100000,
      })
      .then((response) => {
        commit("setLoading", false);
        return response;
      })
      .catch((err) => {
        const res = err.response;
        return res;
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },
  async uploadStoreInvoice({ commit }, postData) {
    commit("setLoading", true);
    const formData = new FormData();
    Object.keys(postData).forEach((key) => {
      if (postData[key] == "null") return;
      if (postData[key]) {
        formData.append(key, postData[key]);
      }
    });

    return axios
      .post(`/api/panel/report/venue-invoice/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 100000,
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        const res = err.response;
        return res;
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },
};

const mutations = {
  setOrderReports: (state, orderReports) => {
    state.orderReports = orderReports;
  },
  setVenueReports: (state, venueReports) => {
    state.venueReports = venueReports;
  },
  setVenueNameList: (state, venueNameList) => {
    state.venueNameList = venueNameList;
    state.venueNameList.unshift({
      id: null,
      venueName: "Hepsi",
    });
  },
  setGraphicReports: (state, graphicReports) => {
    state.graphicReports = graphicReports;
  },
  setLoading(state, value) {
    state.loading = value;
  },
  setStoreAccountingList: (state, storeAccountingList) => {
    state.storeAccountingList = storeAccountingList;
  },
  setStoreMonthlyInvoiceDetail: (state, storeMonthlyInvoiceDetail) => {
    state.storeMonthlyInvoiceDetail = storeMonthlyInvoiceDetail;
  },
  setStoreMonthlyInvoiceDetailTotalAmount: (
    state,
    storeMonthlyInvoiceDetailTotalAmount,
  ) => {
    state.storeMonthlyInvoiceDetailTotalAmount =
      storeMonthlyInvoiceDetailTotalAmount;
  },
  setInvoicePeriods: (state, invoicePeriods) => {
    state.invoicePeriods = invoicePeriods;
  },
  setStoreMonthlyInvoiceSummary: (state, storeMonthlyInvoiceSummary) => {
    state.storeMonthlyInvoiceSummary = storeMonthlyInvoiceSummary;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
